import {
  type FilterCriterion,
  FilterCriterionCategoryEnum,
  SocialPlatformAttributeEnum,
} from '../../../types'

export const CRITERION_DEFAULTS_BY_CATEGORY: {
  [C in FilterCriterionCategoryEnum]: (id: string) => Extract<FilterCriterion, { category: C }>
} = {
  [FilterCriterionCategoryEnum.SocialPlatform]: (id) => ({
    id,
    category: FilterCriterionCategoryEnum.SocialPlatform,
    platform: null,
    attribute: SocialPlatformAttributeEnum.Existing,
    operator: null,
    value: null,
  }),
  [FilterCriterionCategoryEnum.Client]: (id) => ({
    id,
    category: FilterCriterionCategoryEnum.Client,
    client: null,
  }),
  [FilterCriterionCategoryEnum.RevenueTier]: (id) => ({
    id,
    category: FilterCriterionCategoryEnum.RevenueTier,
    revenueTier: null,
  }),
  [FilterCriterionCategoryEnum.Analytics]: (id) => ({
    id,
    category: FilterCriterionCategoryEnum.Analytics,
    advertiser: null,
    metric: null,
    operator: null,
    value: null,
    windowDays: null,
  }),
  [FilterCriterionCategoryEnum.Utm]: (id) => ({
    id,
    category: FilterCriterionCategoryEnum.Utm,
    utmKey: null,
    value: '',
  }),
  [FilterCriterionCategoryEnum.User]: (id) => ({
    id,
    category: FilterCriterionCategoryEnum.User,
    field: null,
    operator: null,
    value: null,
  }),
}
